const escapeHtml = text =>
  String(text ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char])

const styles = color => `
  html, body { margin: 0; height: 100%; font-family: Roboto, Helvetica, Arial, sans-serif; background: #525659; }
  header { display: flex; align-items: center; gap: 12px; height: 52px; padding: 0 16px; background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,.2); }
  header h1 { flex: 1; margin: 0; font-size: 16px; font-weight: 600; color: #212529; }
  header a { padding: 8px 16px; border-radius: 6px; background: ${color}; color: #fff; font-size: 14px; font-weight: 600; text-decoration: none; }
  iframe { display: block; width: 100%; height: calc(100% - 52px); border: 0; }
  .loading { display: grid; place-items: center; height: calc(100% - 52px); color: #fff; font-size: 15px; }
`

// Opens the window right away (still inside the click, so pop-up blockers allow it) and fills it once the PDF is ready
export function openPdfWindow({ title, loading, saveLabel, color = '#1976d2' }) {
  const STYLE = styles(/^#[0-9a-f]{3,8}$/i.test(color) ? color : '#1976d2')
  const win = window.open('', '_blank')
  if (win) {
    win.document.write(
      `<!doctype html><html><head><title>${escapeHtml(title)}</title><style>${STYLE}</style></head>` +
        `<body><header><h1>${escapeHtml(title)}</h1></header><div class="loading">${escapeHtml(loading)}</div></body></html>`,
    )
    win.document.close()
  }

  return {
    show(doc, fileName) {
      const url = URL.createObjectURL(doc.output('blob'))
      if (!win || win.closed) {
        doc.save(fileName)
        return
      }
      win.document.open()
      win.document.write(
        `<!doctype html><html><head><title>${escapeHtml(fileName)}</title><style>${STYLE}</style></head><body>` +
          `<header><h1>${escapeHtml(title)}</h1><a href="${url}" download="${escapeHtml(fileName)}">${escapeHtml(saveLabel)}</a></header>` +
          `<iframe src="${url}" title="${escapeHtml(title)}"></iframe></body></html>`,
      )
      win.document.close()
      win.addEventListener('beforeunload', () => URL.revokeObjectURL(url))
    },
    close() {
      if (win && !win.closed) win.close()
    },
  }
}
